const AppConfig = {
  appName: "Roots"
};

export default AppConfig;



// WEBPACK FOOTER //
// ./src/Config/AppConfig.ts